import { render, staticRenderFns } from "./ui-chip.vue?vue&type=template&id=b81c574e&"
import script from "./ui-chip.vue?vue&type=script&lang=ts&"
export * from "./ui-chip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports